import { Avatar, AvatarImage } from "@/components/ui/avatar";
import { ChartContainer, ChartTooltip, ChartTooltipContent } from "@/components/ui/chart";
import { cn } from "@/lib/utils";
import React, { forwardRef} from "react";
import { CartesianGrid, Line, LineChart, XAxis, YAxis} from "recharts";
import { StoreData } from "modules/main/types/storeData";
import Amount from "utils/amount";
import { getStoreBdData } from "utils/storeDataManager";

interface PriceChartProps extends React.HTMLAttributes<HTMLDivElement>{
    chartData:any[] | undefined,
    storeList: StoreData[]
}

export const PriceChart = forwardRef<HTMLDivElement, PriceChartProps>(({...props}, ref) => {
    let colorIndex = 0;
    const colors = ["hsl(var(--chart-1))", "hsl(var(--chart-2))","hsl(var(--chart-3))",
                    "hsl(var(--chart-4))","hsl(var(--chart-5))","hsl(var(--chart-6))",
                    "hsl(var(--chart-7))","hsl(var(--chart-8))","hsl(var(--chart-9))"];
    const chartConfig: { [key: string]: { label: string; color: string } } = {}
    props.chartData?.forEach((month,index) => {        
        Object.keys(month).forEach((key) => {         
            if(key !== "month" && key !== "display_month" && !chartConfig[key]){
                chartConfig[key] = {
                    label:key,
                    color:colors[colorIndex]
                }
                colorIndex++;
            }
        });
    }
    );

    return (
    <>
    <ChartContainer config={chartConfig}>
        <LineChart
            accessibilityLayer
            data={props.chartData}
            margin={{
                top:12,
                left:12,
                right:12
            }}>
            <CartesianGrid vertical={false}/>
            <YAxis
                tickLine={false}
                axisLine={false}
                tickMargin={8}  
                
            />
            <XAxis
                dataKey="display_month"
                tickLine={false}
                axisLine={false}
                tickMargin={8}                
                tickFormatter={(value)=> value.slice(0,8)}                
                />
            <ChartTooltip cursor={true}
                content={
                <ChartTooltipContent indicator="line"
                formatter={(value,name, payload) => {
                    return (
                    <div className="flex w-full flex-row justify-between gap-4">
                        <div className="flex flex-row items-center gap-2 ">
                            <Avatar className="w-4 h-4">
                                <AvatarImage src={getStoreBdData(Number(name), props.storeList).logo_url}/>  
                            </Avatar>                     
                            <div
                            className={cn(
                                "shrink-0 rounded-[2px] border-[--color-border] bg-[--color-bg]",
                                {
                                    "h-2.5 w-2.5":true,
                                }
                            )}
                            style={
                                {
                                "--color-bg": payload.color,
                                "--color-border": payload.color,
                                } as React.CSSProperties
                            }
                            />                   
                            <span className="text-muted-foreground">{getStoreBdData(Number(name), props.storeList).name}</span>
                        </div>
                        
                        <span className="font-semibold">
                            <Amount 
                                amount={Number(value?.toString() ?? "0")} 
                                currency="CLP" 
                                locale="es-CL" 
                            />
                        </span>
                    </div>)
                    // return `${name} $ ${value.toLocaleString()}`
                }}/>} />
            {
            Object.keys(chartConfig).map((key,index) => {
                return(
                    <Line
                        key={index}
                        dataKey={key}
                        type ="monotone"
                        stroke={chartConfig[key].color}
                        strokeWidth={2}
                        dot={true}
                    />
                );
            }
            )}
        </LineChart>

    </ChartContainer>    
    </>
    );
});